import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const ChecklistActions = {
  getChecklist: async (_, checklistId) => {
    return axiosRequest.
      get(`/checklists/${checklistId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  getChecklists: async _ => {
    return axiosRequest.
      get('/checklists').
      then(({ data }) => data).
      catch(handleError)
  },
}
